<template>
    <!-- 更多属性 -->
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">更多属性</div>
        </div>
        <div class="information_content" style="margin-bottom: 20px">
            <el-tabs type="border-card">
                <el-tab-pane label="产品详情">
                    <div class="d-f mT-10" v-for="(item, index) in infoList" :key="index">
                        <div class="information_Title" style="padding-top: 5px;">
                            <span class="tips" v-if="item.required == 1">*</span>
                            <span>{{ item.titleChinese }}</span>
                            <el-tooltip placement="right-start">
                                <div slot="content" class="el_tip_box">
                                    {{ item.descriptionChinese }}
                                </div>
                                <img :src="urlQueImg" class="item_img" alt />
                            </el-tooltip>
                            <p>{{ item.name }}</p>
                        </div>
                        <div class="mL-10 mT-20 input_el" style="width: 70%;">
                            <div class="newipt" :class="{ flex: item.children.length < 6 }">
                                <div style="width: 100%" v-for="(items, index) in infoListShuxingArr[index]" :key="index">
                                    <el-date-picker class="shuxing_input"
                                        v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                        v-model="items.publishProduct" :placeholder="'请选择' + items.titleChinese + '（' + items.property + '）'"
                                        format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                    <el-input :disabled="isChakan || system < 5"
                                        v-else-if="items.enumValue == null && items.type == 'string'"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese + '（' + items.property + '）'"
                                        v-model="items.publishProduct" show-word-limit
                                        :type="items.maxLength == null ? 'input' : 'textarea'"
                                        :maxlength="items.maxLength">
                                    </el-input>
                                    <el-input :disabled="isChakan || system < 5"
                                        v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese + '（' + items.property + '）'"
                                        v-model="items.publishProduct" show-word-limit type="number"
                                        :max="items.maximum" @input="numberInput(items)" :maxlength="items.maxLength">
                                    </el-input>
                                    <template v-else-if="items.type === 'array'">
                                        <el-select 
                                            class="shuxing_input"
                                            v-model="items.publishProduct"
                                            multiple
                                            filterable
                                            :multiple-limit="items.maxItems"
                                            allow-create
                                            default-first-option
                                            no-data-text="请输入"
                                            clearable
                                            :placeholder="'请输入' + items.titleChinese + '（' + items.property + '）'">
                                            <!-- <el-option v-for="item in (items.enumValue ? items.enumValue : [])" :key="item" :label="item" :value="item">
                                            </el-option> -->
                                        </el-select>
                                    </template>
                                    <el-select :router="true" class="shuxing_input" v-else
                                        v-model="items.publishProduct" clearable filterable
                                        :placeholder="'请选择' + items.titleChinese + '（' + items.property + '）'">
                                        <el-option v-for="selectItem in items.enumValue" :key="selectItem"
                                            :label="selectItem" :value="selectItem">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="安全性和合规性">
                    <div class="d-f mT-10" v-for="(item, index) in securityList" :key="index">
                        <div class="information_Title" style="padding-top: 5px;">
                            <span class="tips" v-if="item.required == 1">*</span>
                            <span>{{ item.titleChinese }}</span>
                            <el-tooltip placement="right-start">
                                <div slot="content" class="el_tip_box">
                                    {{ item.descriptionChinese }}
                                </div>
                                <img :src="urlQueImg" class="item_img" alt />
                            </el-tooltip>
                            <p>{{ item.name }}</p>
                        </div>
                        <div class="mL-10 mT-20 input_el" style="width: 70%;">
                            <div class="newipt" :class="{ flex: item.children.length < 6 }">
                                <div style="width: 100%" v-for="(items, index) in securityListShuxingArr[index]"
                                    :key="index">
                                    <el-date-picker class="shuxing_input"
                                        v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                        v-model="items.publishProduct" :placeholder="'请选择' + items.titleChinese + '（' + items.property + '）'"
                                        format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                    <el-input :disabled="isChakan || system < 5"
                                        v-else-if="items.enumValue == null && items.type == 'string'"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese + '（' + items.property + '）'"
                                        v-model="items.publishProduct" show-word-limit
                                        :type="items.maxLength == null ? 'input' : 'textarea'"
                                        :maxlength="items.maxLength">
                                    </el-input>
                                    <el-input :disabled="isChakan || system < 5"
                                        v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese + '（' + items.property + '）'"
                                        v-model="items.publishProduct" show-word-limit type="number"
                                        :max="items.maximum" @input="numberInput(items)" :maxlength="items.maxLength">
                                    </el-input>
                                    <template v-else-if="items.type === 'array'">
                                        <el-select 
                                            class="shuxing_input"
                                            v-model="items.publishProduct"
                                            multiple
                                            :multiple-limit="items.maxItems"
                                            filterable
                                            allow-create
                                            default-first-option
                                            clearable
                                            no-data-text="请输入"
                                            :placeholder="'请输入' + items.titleChinese + '（' + items.property + '）'">
                                            <!-- <el-option v-for="item in (items.enumValue ? items.enumValue : [])" :key="item" :label="item" :value="item">
                                            </el-option> -->
                                        </el-select>
                                    </template>
                                    <el-select :router="true" class="shuxing_input" v-else
                                        v-model="items.publishProduct" clearable filterable
                                        :placeholder="'请选择' + items.titleChinese + '（' + items.property + '）'">
                                        <el-option v-for="selectItem in items.enumValue" :key="selectItem"
                                            :label="selectItem" :value="selectItem">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
export default {
    components: {},
    data() {
        return {
            // 问号图标
            urlQueImg: require('@/assets/images/wenhao.png'),
            infoList: [],
            infoListShuxingArr: [],
            securityList: [],
            securityListShuxingArr: []
        };
    },
    props: {
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
    },
    methods: {
        getData() {
            // 返回所有当前 data
            return { ...this.$data };
        },
        resetData() {
            // 用 Object.assign 替换 this 上的数据为初始状态
            Object.assign(this.$data, this.$options.data.call(this));
        },
        numberInput(items) {
            if (items.maximum != null) {
                if (parseFloat(items.publishProduct) > items.maximum) {
                    items.publishProduct = items.maximum
                }
            }
            if(items.publishProduct){
                this.$set(items, 'publishProduct', +items.publishProduct);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";

.shuxing_input {
    width: 100%;
    padding: 5px 0px;
}

.el_tip_box {
    width: 360px;
    font-size: 18px;
    background: rgb(39, 39, 39);
    border-radius: 10px;
    padding: 15px;
    color: whitesmoke;
}

.item_img {
    height: 16px;
    width: 16px;
    margin-left: 5px;
    cursor: pointer;
}

.information_Title {
    width: 20%;
    overflow: hidden;
    color: #7d7171;
    text-align: right;
    float: left;
    line-height: 33px;
    margin-right: 1%;
    font-weight: bold;
    user-select: none;

    .tips {
        color: red;
    }
}

.flex {
    display: flex;
}
</style>